<wiz-hgroup #hgContainer height="100%" width="100%" verticalAlign="center" gap="10" style="justify-content: center">
  <wiz-icon [wizTooltip]="'$.common.discover.$'">see</wiz-icon>
  <wiz-icon [wizTooltip]="'$.common.clone.$'">duplicate</wiz-icon>
</wiz-hgroup>
